import * as Yup from "yup";

export const productOptionsValidation = Yup.object().shape({
  value: Yup.string().required("وارد کردن نام الزامی است"),
  price: Yup.string().required("وارد کردن قیمت الزامی است"),
});
